// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3gAQX","left":"StickyBox_left___beJE","right":"StickyBox_right__3fT5K"};